import React from 'react';
import { Link, LinkProps } from 'react-router-dom';

import { FLEET_ID_QUERY_PARAM_KEY } from '../../constants/queryParams';
import { APP_ROUTES, CHAT_SESSION_ID_QUERY_PARAM_KEY } from '../../constants/routes';

/**
 * Adds fleet_id to a path if present in the current URL.
 * Reads from window.location because fleet_id can be set via replaceState.
 */
export const preserveFleetId = (path: string): string => {
  const fleetId = new URLSearchParams(window.location.search).get(FLEET_ID_QUERY_PARAM_KEY);
  if (!fleetId) {
    return path;
  }

  const [basePath, existingSearch] = path.split('?');
  const params = new URLSearchParams(existingSearch || '');
  if (!params.has(FLEET_ID_QUERY_PARAM_KEY)) {
    params.set(FLEET_ID_QUERY_PARAM_KEY, fleetId);
  }

  return `${basePath}?${params.toString()}`;
};

const preserveChatSessionId = (path: string): string => {
  const chatSessionId = new URLSearchParams(window.location.search).get(CHAT_SESSION_ID_QUERY_PARAM_KEY);
  const [basePath, existingSearch] = path.split('?');
  if (basePath !== APP_ROUTES.chat || !chatSessionId) {
    return path;
  }

  const params = new URLSearchParams(existingSearch || '');
  if (!params.has(CHAT_SESSION_ID_QUERY_PARAM_KEY)) {
    params.set(CHAT_SESSION_ID_QUERY_PARAM_KEY, chatSessionId);
  }

  return `${basePath}?${params.toString()}`;
};

/**
 * Link that preserves fleet context and an active chat session when navigating to chat.
 */
export const QueryPreservingLink: React.FC<LinkProps> = ({ to, children, ...props }) => {
  const preservedTo = typeof to === 'string' ? preserveChatSessionId(preserveFleetId(to)) : to;

  return (
    <Link to={preservedTo} {...props}>
      {children}
    </Link>
  );
};
